import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { shippingService } from '../services/shipping.service';

/**
 * Hook to fetch shipping rates for a specific shop
 */
export function useShopShippingRates(shopRefId: string) {
  return useQuery({
    queryKey: ['shippingRates', 'shop', shopRefId],
    queryFn: () => shippingService.getShopShippingRates(shopRefId),
    enabled: !!shopRefId,
  });
}

/**
 * Hook to associate shipping rates with a shop
 */
export function useAssociateShippingRates() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ shopRefId, rateRefIds }: { shopRefId: string; rateRefIds: string[] }) =>
      shippingService.associateRatesWithShop(shopRefId, rateRefIds),
    onSuccess: (_, { shopRefId }) => {
      queryClient.invalidateQueries({ queryKey: ['shippingRates', 'shop', shopRefId] });
      queryClient.invalidateQueries({ queryKey: ['shop', shopRefId] });
    },
  });
}

/**
 * Hook to disassociate shipping rates from a shop
 */
export function useDisassociateShippingRates() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ shopRefId, rateRefIds }: { shopRefId: string; rateRefIds: string[] }) =>
      shippingService.disassociateRatesFromShop(shopRefId, rateRefIds),
    onSuccess: (_, { shopRefId }) => {
      queryClient.invalidateQueries({ queryKey: ['shippingRates', 'shop', shopRefId] });
      queryClient.invalidateQueries({ queryKey: ['shop', shopRefId] });
    },
  });
}
